import React, { useEffect, useState } from "react";
import { Trophy, RotateCcw, Home, Swords, Target } from "lucide-react";
import WinCelebration from "../WinCelebration";

// Final shootout summary with coins outcome.
export const ShootoutResult = ({ s, me, them, busy, onRematch, onAccept, onNew, onHome, onPepAgain }) => {
  const won = s.winner === me.email;
  const prize = s.pep ? (s.stake ? s.stake * 2 : 10) : s.friendly ? 0 : s.pot;
  const seenKey = `fc_celebrated_${s.id}`;
  const [celebrate, setCelebrate] = useState(() => won && prize > 0 && !localStorage.getItem(seenKey));
  useEffect(() => { if (celebrate) localStorage.setItem(seenKey, "1"); }, [celebrate, seenKey]);
  const invitedMe = s.rematch_id && s.rematch_by_email !== me.email;
  const mine = s.score[me.role];
  const theirs = s.score[them.role];
  const tie = s.winner === "tie";
  const title = tie ? "All square" : won ? "You win the shootout!" : `${them.username} wins it`;
  const sub = s.pep
    ? tie ? (s.stake ? `Honours even with Pep. £${s.stake} refunded.` : "Honours even with Pep.") : won ? `+£${s.stake ? s.stake * 2 : 10} for beating Pep from the spot!` : s.stake ? `Pep's side held their nerve. You lost your £${s.stake} stake.` : "Pep's side held their nerve. Go again?"
    : s.friendly
    ? "Friendly shootout, nothing on the line."
    : tie
    ? `Stakes refunded (£${s.stake}).`
    : won
    ? `+£${s.pot} added to your balance.`
    : `You lost your £${s.stake} stake.`;
  return (
    <div data-testid="shootout-result" className="card-38 p-6 hover:translate-y-0 text-center pop-in">
      <WinCelebration open={celebrate} amount={prize} label={`Penalty Shootout · you beat ${them.username} ${mine}–${theirs}`} onClose={() => setCelebrate(false)}
        onAgain={s.pep ? onPepAgain : undefined} againLabel={`Play Pep again${s.stake ? ` · £${s.stake}` : ""}`} />
      <div className={`mx-auto w-16 h-16 rounded-full flex items-center justify-center ${won ? "bg-[#10B981]" : "bg-white/10"}`}>
        <Trophy className={`w-8 h-8 ${won ? "text-[#0F172A]" : "text-slate-300"}`} />
      </div>
      <h2 data-testid="shootout-result-title" className="font-display font-extrabold text-2xl mt-3 text-white">{title}</h2>
      <div data-testid="shootout-final-score" className="font-display font-extrabold text-5xl mt-2 tabular-nums">
        <span className={won ? "text-[#10B981]" : "text-white"}>{mine}</span>
        <span className="text-slate-500 mx-2">–</span>
        <span className={!won && !tie ? "text-[#EF4444]" : "text-white"}>{theirs}</span>
      </div>
      <p data-testid="shootout-result-sub" className="text-slate-300 text-sm mt-2">{sub}</p>
      {s.pep ? (
        <button data-testid="shootout-pep-again-btn" onClick={onPepAgain} disabled={busy} className="btn-green wager-glow w-full rounded-xl py-4 mt-5 font-extrabold text-lg flex items-center justify-center gap-2 disabled:opacity-50">
          <RotateCcw className="w-5 h-5" /> {busy ? "Setting up…" : `Play Pep again${s.stake ? ` · £${s.stake}` : ""}`}
        </button>
      ) : invitedMe ? (
        <button data-testid="shootout-accept-rematch-btn" onClick={onAccept} className="btn-green wager-glow w-full rounded-xl py-4 mt-5 font-extrabold text-lg flex items-center justify-center gap-2">
          <Swords className="w-5 h-5" /> {s.rematch_by} wants a rematch. Accept
        </button>
      ) : (
        <button data-testid="shootout-rematch-btn" onClick={onRematch} disabled={busy} className="btn-green wager-glow w-full rounded-xl py-4 mt-5 font-extrabold text-lg flex items-center justify-center gap-2 disabled:opacity-50">
          <RotateCcw className="w-5 h-5" /> {busy ? "Sending…" : `Rematch ${them.username}${s.stake ? ` · £${s.stake}` : ""}`}
        </button>
      )}
      <div className="grid grid-cols-2 gap-2 mt-2">
        <button data-testid="shootout-new-btn" onClick={onNew} className="btn-ghost rounded-xl py-3 font-semibold text-white flex items-center justify-center gap-1.5">
          <Target className="w-4 h-4" /> New shootout
        </button>
        <button data-testid="shootout-home-btn" onClick={onHome} className="btn-ghost rounded-xl py-3 font-semibold text-white flex items-center justify-center gap-1.5">
          <Home className="w-4 h-4" /> Home
        </button>
      </div>
    </div>
  );
};

export default ShootoutResult;
